import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ConcernedAboutRevealingModal from './concerned_about_revealing_modal';

function FieldName({
                     name,
                     onBlur,
                     requestType,
                     setName,
                     highlightTitle,
                   }) {
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);

  let label;
  let exampleText;
  let revealStoryIdea = true;
  let placeholder;
  let highlightTitleText;
  switch (requestType) {
    case 'exposure':
      label = 'Title of your article';
      exampleText = '';
      placeholder = 'The title of your article';
      revealStoryIdea = false;
      highlightTitleText = 'Give this a unique title';
      break;
    case 'guests':
      label = 'What kind of guest are you looking for?';
      exampleText = 'ex: Experienced driver needed for podcast episode on adventure travel tourism and its effect on the environment';
      highlightTitleText = 'Give this a unique title to attract new guests';
      break;
    case 'speakers':
      label = 'What type of speaker are you looking for?';
      exampleText = 'ex: Seeking panelist for webinar on cyber security in the financial sector';
      highlightTitleText = 'Give this a unique title to attract new speakers';
      break;
    case 'story_ideas':
      label = 'What topic would you like story ideas for?';
      exampleText = 'ex: Need topics for weekly column on health and wellness';
      revealStoryIdea = false;
      break;
    case 'products':
      label = 'What type of products are you looking for?';
      exampleText = 'ex: Need Father\'s Day gifts for dads who like the outdoors';
      placeholder = 'Summarize your post in one line — what are you looking for?';
      highlightTitleText = 'Give this a unique title';
      revealStoryIdea = false;
      break;
    case 'man_on_the_street':
        label = 'What is the topic or question covered in your interview?';
        exampleText = 'ex: Looking for shoppers to discuss how rising grocery prices impact personal finances';
        placeholder = 'It\'s best to summarize your post in one line';
        highlightTitleText = 'Give this a unique title';
        revealStoryIdea = false;
        break;
    default:
      // also 'experts'
      placeholder = 'Summarize your post in one line — what are you looking for?';
      label = 'What kind of expert are you looking for?';
      exampleText = 'ex. Immunologist needed for opinions on booster administration.';
      highlightTitleText = 'Give this a unique title to attract new experts';
      break;
  }

  return (
    <div className={`mb-3 ${requestType == 'exposure' ? 'col-md-6' : ''}`}>
      <label htmlFor="name" className="fw-bold">
        {label}
        <span style={{ color: '#E71E42' }}> &#42;</span>
        <div className="text-secondary fst-italic fw-light my-1">
          {exampleText}
        </div>
      </label>
      <input
        className={`w-100 mb-1 form-control border ${highlightTitle ? 'border-danger' : ''}`}
        defaultValue={name}
        id="name"
        name="name"
        onBlur={() => onBlur()}
        onInput={(e) => setName(e.target.value)}
        placeholder={placeholder}
        required
        type="text"
      />
      {highlightTitle && (
        <div className="text-raspberry-80 fst-italic fw-light my-1">
          {highlightTitleText}
        </div>
      )}
      {revealStoryIdea && (
        <button type="button" className="btn btn-link p-0 text-start" onClick={toggleModal}>
          <em>Concerned About Revealing Your Story Idea?</em>
        </button>
      )}
      {revealStoryIdea && modalOpen && (
        <ConcernedAboutRevealingModal isOpen={modalOpen} toggle={toggleModal} />
      )}
    </div>
  );
}

FieldName.propTypes = {
  name: PropTypes.string,
  onBlur: PropTypes.func,
  requestType: PropTypes.string,
  setName: PropTypes.func,
  highlightTitle: PropTypes.bool,
};

FieldName.defaultProps = {
  name: undefined,
  onBlur: undefined,
  requestType: undefined,
  setName: undefined,
  highlightTitle: false,
};

export default FieldName;
